// System directives

"use client";

// System dependencies

import React, { useState } from "react";
import { useController, Control, FieldValues, Path } from "react-hook-form";

// Application dependencies

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

// Styling

import { BiHide, BiShow } from "react-icons/bi";

// Props

interface FormInputPasswordProps<T extends FieldValues> {
  control: Control<T>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  label: string;
  name: Path<T>;
  placeholder?: string;
  type?: string;
}

const FormInputPassword = <T extends FieldValues>({ control, name, label, placeholder, inputProps }: FormInputPasswordProps<T>) => {
  // Application state

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FormField
      control={control}
      name={name}
      render={() => (
        <FormItem>
          <FormLabel className="text-base">{label}</FormLabel>
          <FormControl>
            <div className="relative flex items-center">
              <Input
                {...field}
                {...inputProps}
                className="rounded bg-white !text-base dark:bg-slate-700"
                placeholder={placeholder}
                type={showPassword ? "text" : "password"}
              />
              <span className="absolute right-0 pr-2" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <BiHide className="text-body h-6 w-6 opacity-70" /> : <BiShow className="text-body h-6 w-6 opacity-70" />}
              </span>
            </div>
          </FormControl>
          {!error && <FormDescription className="text-base">{placeholder}</FormDescription>}
          <FormMessage className="text-base" />
        </FormItem>
      )}
    />
  );
};

export default FormInputPassword;
